import {
  FormElementsSelectorBack,
  FormElementsSelectorBottom
} from '@/components/FormElement/FormElementsSelectorPopupButtons/FormElementsSelectorPopup/FormElementsSelectorBottom'
import {
  type V1ViewBottomActionButtons,
  type V1ViewBottom
} from 'mnvm-mypage-app-ts-if'
import { onBack, onReset } from './fn'
import { FormElementsSelectorContext } from './context'
import { useContext } from 'react'
import { useJobPostingAdvancedSearchConditionBackup } from '@/hooks/useJobPostingAdvancedSearchConditionBackup'

interface Props {
  view?: V1ViewBottom
  onSubmit?: () => void
  onSelect?: (
    items: string[],
    text: string,
    municipalityMap?: Record<string, string[]>
  ) => void
  onClose?: () => void
}
export const FormElementsSelectorBottomContainer = ({
  view,
  onSubmit,
  onSelect,
  onClose
}: Props): JSX.Element => {
  const { buttons } = view?.data as V1ViewBottomActionButtons

  if ((buttons ?? []).length === 0) return <></>

  const { state, dispatch } = useContext(FormElementsSelectorContext)
  const [conditionBackup, updateConditionBackup] =
    useJobPostingAdvancedSearchConditionBackup()

  return (
    <FormElementsSelectorBottom
      onReset={() => {
        if (state.values.length > 0) {
          onReset(dispatch)
          onSelect?.([], '', {})
        }
        updateConditionBackup({ ...conditionBackup, municipalityMap: {} })
        onClose?.()
      }}
      onSubmit={onSubmit}
      buttons={buttons ?? []}
    />
  )
}

export const FormElementsSelectorBackContainer = (): JSX.Element => {
  const { state, dispatch } = useContext(FormElementsSelectorContext)

  if (state.items.length < 2) return <></>

  return (
    <FormElementsSelectorBack
      onClick={() => {
        onBack(dispatch)
      }}
    />
  )
}
